document.addEventListener('DOMContentLoaded', () => {
  bindVueGraphLoader()
})


function bindVueGraphLoader() {

  jQuery("#invisible-event-bridge").off('graph-loader').on('graph-loader', function(e) {
    e.stopPropagation()
    jQuery("#total-spend-graph-container").html(loaderHTML('We are working hard to fetch your data...'))
    jQuery("#location-spend-graph-container").html(loaderHTML('We are working hard to fetch your data...'))
  })
}

function loaderHTML(message='loader') {
    return `
      <div class="loader-wrapper">
        <div class="loader">
            <div class="loader-1"></div>
            <div class="loader-2"></div>
            <div class="loader-3"></div>
            <div class="loader-4"></div>
        </div>
        <div class="loader-message text-center"><p>${message}</p></div>
      </div>
    `
}
